import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";

const BannerSwipe = () => {
  const banners = [
    "/tqneen/bg-banner.png",
    "/tqneen/bg-banner.png",
    "/tqneen/bg-banner.png",
    "/tqneen/bg-banner.png",
  ];

  return (
    <>
      {/* <h2 className="text-2xl font-bold my-6 text-center underline">معلومات قانونية</h2> */}
      <div className="px-4">
        <Swiper
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView="auto"
          initialSlide={1}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2,
            slideShadows: false,
          }}
          pagination={{ clickable: true }}
          modules={[Pagination, EffectCoverflow]}
          className="!pb-12"
          onInit={(swiper) => {
            // Add overlay to all slides
            swiper.slides.forEach((slide) => {
              const overlay = slide.querySelector('.slide-overlay');
              if (overlay) {
                overlay.classList.add('bg-black/50');
              }
            });
            // Remove overlay from active slide
            const activeSlide = swiper.slides[swiper.activeIndex];
            const activeOverlay = activeSlide.querySelector('.slide-overlay');
            if (activeOverlay) {
              activeOverlay.classList.remove('bg-black/50');
            }
          }}
          onSlideChange={(swiper) => {
            // Add overlay to all slides
            swiper.slides.forEach((slide) => {
              const overlay = slide.querySelector('.slide-overlay');
              if (overlay) {
                overlay.classList.add('bg-black/50');
              }
            });
            // Remove overlay from active slide
            const activeSlide = swiper.slides[swiper.activeIndex];
            const activeOverlay = activeSlide.querySelector('.slide-overlay');
            if (activeOverlay) {
              activeOverlay.classList.remove('bg-black/50');
            }
          }}
        >
          {banners.map((img, index) => (
            <SwiperSlide
              key={index}
              className="!w-[280px] md:!w-[400px] lg:!w-[500px] transition-all duration-300"
            >
              <div className="relative aspect-[16/9] w-full rounded-2xl overflow-hidden">
                <Image
                  src={img}
                  alt={`Banner ${index}`}
                  layout="fill"
                  priority
                  className="object-cover"
                  sizes="(max-width: 640px) 280px, (max-width: 768px) 400px, 500px"
                />
                <div className="slide-overlay absolute inset-0 bg-black/50 transition-all duration-300" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default BannerSwipe;
